import { UpdateNameFlow, User, UserActionTypes, UserOrder, UserOrdersDetails } from "./types";

export const updateUser = (user: User | null): UserActionTypes => ({
  type: 'UPDATE_USER',
  payload: user,
});

export const setUpdateNameInputs = (inputs: UpdateNameFlow): UserActionTypes => ({
  type: 'SET_UPDATE_NAME_INPUTS',
  payload: inputs
})

export const getUserOrdersSuccess = (payload: { orders: UserOrder[], details: UserOrdersDetails }): UserActionTypes => ({
  type: 'GET_USER_ORDERS_SUCCESS',
  payload
})

export const getUserOrdersFailure = (payload: string): UserActionTypes => ({
  type: 'GET_USER_ORDERS_FAILURE',
  payload
})

// Action for successful user location retrieval
export const getUserLocationsSuccess = (
  locations: Location[]
): UserActionTypes => ({
  type: 'GET_USER_LOCATIONS_SUCCESS',
  payload: locations,
});

// Action for failed user location retrieval
export const getUserLocationsFailure = (error: string): UserActionTypes => ({
  type: 'GET_USER_LOCATIONS_FAILURE',
  payload: error,
});


// Action for successful user transaction retrieval
export const getUserTransactionsSuccess = (payload: any): UserActionTypes => ({
  type: 'GET_USER_TRANSACTIONS_SUCCESS',
  payload,
});

// Action for failed user transaction retrieval
export const getUserTransactionsFailure = (
  error: string
): UserActionTypes => ({
  type: 'GET_USER_TRANSACTIONS_FAILURE',
  payload: error,
});

// Action to set the selected user view
export const setUserView = (view: string): UserActionTypes => ({
  type: 'SET_USER_VIEW',
  payload: view,
});